const filters = {
    preFilter: function(val, option){
        if(!option){
            return val
        }else{
            return filters[option](val);
        }
    },
    splitarray: function(val){
        return val ? val.join(',') : val
    },
    nullValue: function (value) {
        return value != null && value != undefined ? value : '-'
    },
    overMillion: function(val){
        if(val.toString().length > 4){
            return (Number(val.toString().replace(/,+/g, "")) / 10000).toFixed(1) + 'w'
        }else{
            return val
        }
    }
}
export default filters
